var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/tag-input/tag-input.tsx";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import React, { useState } from 'react';
import HStack from '../hstack/hstack';
import Tag from './tag';

/** Manage a list of tags. */
// https://blog.logrocket.com/building-a-tag-input-field-component-for-react/
const TagInput = _ref => {
  let {
    tags,
    onChange,
    placeholder
  } = _ref;
  const [input, setInput] = useState('');

  const handleTagDelete = tag => {
    onChange(tags.filter(item => item !== tag));
  };

  const handleKeyDown = e => {
    const {
      key
    } = e;
    const trimmedInput = input.trim();

    if (key === 'Tab') {
      e.preventDefault();
    }

    if ([',', 'Tab', 'Enter'].includes(key) && trimmedInput.length && !tags.includes(trimmedInput)) {
      e.preventDefault();
      onChange([...tags, trimmedInput]);
      setInput('');
    }

    if (key === 'Backspace' && !input.length && tags.length) {
      e.preventDefault();
      const tagsCopy = [...tags];
      tagsCopy.pop();
      onChange(tagsCopy);
    }
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "mt-1 relative shadow-sm flex-grow",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(HStack, {
    className: "p-2 pb-0 text-gray-900 dark:text-gray-100 placeholder:text-gray-600 dark:placeholder:text-gray-600 block w-full sm:text-sm dark:ring-1 dark:ring-gray-800 focus:ring-primary-500 focus:border-primary-500 dark:focus:ring-primary-500 dark:focus:border-primary-500 rounded-md bg-white dark:bg-gray-900 border-gray-400 dark:border-gray-800",
    space: 2,
    wrap: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 47,
      columnNumber: 7
    }
  }, tags.map((tag, i) => /*#__PURE__*/React.createElement("div", {
    className: "mb-2",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 11
    }
  }, /*#__PURE__*/React.createElement(Tag, {
    tag: tag,
    onDelete: handleTagDelete,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 13
    }
  }))), /*#__PURE__*/React.createElement("input", {
    className: "p-1 mb-2 w-32 h-8 flex-grow bg-transparent outline-none",
    value: input,
    placeholder: placeholder,
    onChange: e => setInput(e.target.value),
    onKeyDown: handleKeyDown,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 58,
      columnNumber: 9
    }
  })));
};

export default TagInput;